import React, { PureComponent } from 'react';

import { ReactComponent as SignalOffLight } from './images/webapp-icon-cellular-off-light-theme.svg';
import { ReactComponent as SignalOffDark } from './images/webapp-icon-cellular-off-dark-theme.svg';
import { ReactComponent as StateOnlineLight } from './images/webapp-icon-online-light-theme.svg';
import { ReactComponent as StateOnlineDark } from './images/webapp-icon-online-dark-theme.svg';
import { ReactComponent as StateOfflineLight } from './images/webapp-icon-offline-light-theme.svg';
import { ReactComponent as StateOfflineDark } from './images/webapp-icon-offline-dark-theme.svg';
import { ReactComponent as UnpluggedLight } from './images/webapp-icon-unplugged-light-theme.svg';
import { ReactComponent as UnpluggedDark } from './images/webapp-icon-unplugged-dark-theme.svg';
import { ReactComponent as AlertLight } from './images/webapp-icon-alert-light-theme.svg';
import { ReactComponent as AlertDark } from './images/webapp-icon-alert-dark-theme.svg';
import { ReactComponent as NoSDCardLight } from './images/webapp-icon-sd-card-removed-light-theme.svg';
import { ReactComponent as NoSDCardDark } from './images/webapp-icon-sd-card-removed-dark-theme.svg';
import { ReactComponent as SDCardAlertLight } from './images/webapp-icon-sd-card-alert-light-theme.svg';
import { ReactComponent as SDCardAlertDark } from './images/webapp-icon-sd-card-alert-dark-theme.svg';
import { ReactComponent as SDCardLight } from './images/webapp-icon-sd-card-inserted-light-theme.svg';
import { ReactComponent as SDCardDark } from './images/webapp-icon-sd-card-inserted-dark-theme.svg';
import { ReactComponent as DTCAlertLight } from './images/webapp-icon-engine-alert-light-theme.svg';
import { ReactComponent as DTCAlertDark } from './images/webapp-icon-engine-alert-dark-theme.svg';
import { ReactComponent as ParkedLight } from './images/webapp-icon-parked-light-theme.svg';
import { ReactComponent as ParkedDark } from './images/webapp-icon-parked-dark-theme.svg';
import { ReactComponent as OpenInModalDark } from './images/webapp-icon-open-in-modal-light-theme.svg';
import { ReactComponent as OpenInModalLight } from './images/webapp-icon-open-in-modal-light-theme.svg';
import { ReactComponent as BadInstallationDetectedLight } from './images/webapp-icon-bad-installation-detected-light-theme.svg';
import { ReactComponent as BadInstallationDetectedDark } from './images/webapp-icon-bad-installation-detected-dark-theme.svg';
import { ReactComponent as SeasonalSuspendLight } from './images/webapp-icon-seasonal-suspend-light-theme.svg';
import { ReactComponent as SeasonalSuspendDark } from './images/webapp-icon-seasonal-suspend-dark-theme.svg';

import { ReactComponent as CarBatteryLowLightAndDark } from './images/webapp-icon-car-battery-low.svg';

import { ReactComponent as Battery100Light } from './images/webapp-icon-battery-100-light-theme.svg';
import { ReactComponent as Battery100Dark } from './images/webapp-icon-battery-100-dark-theme.svg';
import { ReactComponent as Battery75Light } from './images/webapp-icon-battery-075-light-theme.svg';
import { ReactComponent as Battery75Dark } from './images/webapp-icon-battery-075-dark-theme.svg';
import { ReactComponent as Battery50Light } from './images/webapp-icon-battery-050-light-theme.svg';
import { ReactComponent as Battery50Dark } from './images/webapp-icon-battery-050-dark-theme.svg';
import { ReactComponent as Battery25Light } from './images/webapp-icon-battery-025-light-theme.svg';
import { ReactComponent as Battery25Dark } from './images/webapp-icon-battery-025-dark-theme.svg';
import { ReactComponent as Battery0Light } from './images/webapp-icon-battery-000-light-theme.svg';
import { ReactComponent as Battery0Dark } from './images/webapp-icon-battery-000-dark-theme.svg';
import { ReactComponent as BatteryUnknownLight } from './images/webapp-icon-battery-unknown-light-theme.svg';
import { ReactComponent as BatteryUnknownDark } from './images/webapp-icon-battery-unknown-dark-theme.svg';

import { ReactComponent as True } from './images/webapp-icon-checkmark.svg';
import { ReactComponent as False } from './images/webapp-icon-x.svg';


export default class StatusIcon extends PureComponent {

    constructor()
    {

        super();

        // Icons, no array means it switches light/dark in CSS, array means light/dark separate icons
        this.icons = {
            'unplugged': [<UnpluggedLight />, <UnpluggedDark />],
            'sdcard-alert': [<SDCardAlertLight />, <SDCardAlertDark /> ],
            'sdcard-no': [<NoSDCardLight />, < NoSDCardDark /> ],
            'sdcard': [<SDCardLight />, <SDCardDark />],
            'alert': [<AlertLight />, <AlertDark />],
            'no-signal': [<SignalOffLight />, <SignalOffDark />],
            'online': [<StateOnlineLight />, <StateOnlineDark />],
            'offline': [<StateOfflineLight />, <StateOfflineDark />],
            'dtc-active': [<DTCAlertLight />, <DTCAlertDark />],
            'bad-installation-detected': [<BadInstallationDetectedLight />, <BadInstallationDetectedDark />],
            'car-battery-low': [<CarBatteryLowLightAndDark />, <CarBatteryLowLightAndDark />],
            'parked': [<ParkedLight />, <ParkedDark />],
            'battery-100': [<Battery100Light />, <Battery100Dark />],
            'battery-75': [<Battery75Light />, <Battery75Dark />],
            'battery-50': [<Battery50Light />, <Battery50Dark />],
            'battery-25': [<Battery25Light />, <Battery25Dark />],
            'battery-0': [<Battery0Light />, <Battery0Dark />],
            'battery-unknown': [<BatteryUnknownLight />, <BatteryUnknownDark />],
            'open-in-modal': [<OpenInModalLight />, <OpenInModalDark />],
            'suspended': [<SeasonalSuspendLight />, <SeasonalSuspendDark />],
            'true': [<True />, <True />],
            'false': [<False />, <False />],
        };
    }
    

    render() {

        var icondata = this.icons[this.props.type];

        if(!icondata)
        {
            return this.renderSingle(this.icons['alert'], this.props.title);
        }

        if(Array.isArray(icondata))
        {
            return this.renderIcon(icondata, this.props.title);
        }

        else
        {
            return this.renderSingle(icondata, this.props.title);
        }

    }

    renderSingle(content, title) {
        return ( <span className="icon-container" title={title}> { content } </span>);
    }

    renderIcon(icons, title) {
        return ( <span className="icon-container" title={title}> { icons[this.props.theme==="light" ? 0 : 1] } </span>);
    }

}
